import React from "react";
import PropTypes from "prop-types";
import { Tab } from "rbx";
import { Link } from "@reach/router";

import { capitalize } from "../../utils";

const Tabs = ({ links, location }) => (
  <Tab.Group align="right" kind="boxed">
    {links.map((link, i) => (
      <Tab
        active={location.pathname.includes(link)}
        as={Link}
        key={i}
        tabIndex="-1"
        to={link}
      >
        <span>{capitalize(link)}</span>
      </Tab>
    ))}
  </Tab.Group>
);

Tabs.propTypes = {
  links: PropTypes.array,
  location: PropTypes.object.isRequired
};
Tabs.defaultProps = [];
export default Tabs;
